import React, { FC } from 'react';
import classnames from 'classnames';

import { Heading } from '@savebetter/components';

import { useBankProducts } from '../context/BankProductsContext';
import { useDatasources } from '../context/DataSourceContext';
import { useCustomVar } from '../hooks/useCustomVar';

const titleClasses = (isWhite: boolean, logoLen: boolean): string =>
  classnames('pt-3 whitespace-pre-line lg:min-h-0 break-word', 'md:pt-0 md:h-auto', {
    'text-white': isWhite,
    'min-h-40': !logoLen,
    'mb-8 md:mb-3': logoLen
  });

const PageTitle: FC<{ title: string; isTextWhite: boolean; logoLen: boolean }> = ({ title, isTextWhite, logoLen }) => {
  const { contextProducts } = useBankProducts();
  const { contextDatasources } = useDatasources();
  const { resolvedText, textOpacityClass } = useCustomVar(title, contextProducts, contextDatasources);

  return (
    <Heading
      kind="1"
      className={`${textOpacityClass} transition-opacity  ${titleClasses(isTextWhite, Boolean(logoLen))} min-h-0`}
    >
      {resolvedText}
    </Heading>
  );
};

export default PageTitle;
